<template>
    <transition name="fade">
        <div class="zm-message" :class="type" v-if="visible">
            <div class="zm-message-group">
                <div class="zm-message-title">{{$t(i18nPage+title)}}（<span style="color: red">{{msgTotle}}</span><span v-if="outFlag" style="color: red">..</span>）</div>
                <div class="zm-message-content" @click="readMsg">
                    <p>{{content}}</p>
                </div>
                <div style="height: 20px;width:270px;text-align: right;">
                    <a style="text-decoration:none;float: left;" href="javaScript:void(0);" @click="msgIgnoreAll">{{$t(i18nPage+'忽略全部')}}</a>
                    <a style="text-decoration:none" href="javaScript:void(0);" @click="msgRemind">{{$t(i18nPage+'不再提醒')}}</a>
                    <a style="margin-left: 8px;text-decoration:none" href="javaScript:void(0);" @click="readNext">{{$t(i18nPage+'忽略')}}</a>
                    <a style="margin-left: 8px;text-decoration:none" href="javaScript:void(0);" @click="msgReply" v-if="replyFlag">{{$t(i18nPage+'回复')}}</a>
                </div>
                <!--<div v-if="hasClose" class="zm-message-btn el-icon-close" @click="visible=false"></div>-->
                <div v-if="hasClose" class="zm-message-btn">
                    <a style="text-decoration:none" href="javaScript:void(0);" @click="readNext">{{$t(i18nPage+'下一条')}}</a>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "MyMessage",
        beforeCreate() {
            this.i18nPage = 'component.ZmMessage.';
        },
        data() {
            return {
                i18nPage : 'component.ZmMessage.',
                title:'新消息',
                content: '',
                time: 45000,
                visible: false,
                type:'info',
                hasClose:true,
                msgTotle:1,
                msgCount:0,
                msgList:[],
                msgIndex:0,
                replyCallback:null,
                remindCallback:null,
                readCallBack:null,
                replyFlag:false,
                msgTimer:null,
                outFlag:false
            }
        },
        mounted() {
            this.close();
            if(this.msgList && this.msgList.length > 0){
                this.msgTotle = this.msgList.length;
                this.msgIndex = 0;
                this.content = this.msgList[0].msgTitle;
                this.replyFlag = this.msgList[0].msgType && this.msgList[0].msgType === '2';
                this.outFlag = this.msgCount > 99;
            }
        },
        methods: {
            close() {
                if(this.time !== 0){
                    this.msgTimer = window.setTimeout(() =>{
                        this.visible = false
                    }, this.time);
                }
            },
            readNext(){
                if(this.msgTotle === 1){
                    this.$util.show(this.$t(this.i18nPage+'已是最后一条消息,2秒后自动关闭'),1);
                    let that = this;
                    window.setTimeout(() => {
                        that.clearClose();
                    },2000);

                }else{
                    this.msgTotle --;
                    this.msgIndex ++;
                    this.content = this.msgList[this.msgIndex].msgTitle;
                    this.replyFlag = this.msgList[this.msgIndex].msgType && this.msgList[this.msgIndex].msgType === '2';
                    this.outFlag = false;
                }
            },
            msgIgnoreAll(){
                this.clearClose();
            },
            msgRemind(){
                if(this.remindCallback){
                    this.remindCallback(this.msgList[this.msgIndex]);
                }
                this.readNext();
            },
            msgReply(){
                if(this.replyCallback){
                    this.replyCallback(this.msgList[this.msgIndex]);
                }
            },
            readMsg(){
                if(this.readCallBack){
                    this.readCallBack(this.msgList[this.msgIndex]);
                }
                this.clearClose();
            },
            clearClose(){
                if(this.msgTimer){
                    window.clearTimeout(this.msgTimer);
                }
                this.visible = false;
            }

        }
    }
</script>
<style>
    .zm-message {
        position: fixed;
        right: 25px;
        bottom: 25px;
        height: 150px;
        display: flex;
        width: 330px;
        padding: 14px 26px 14px 13px;
        border-radius: 8px;
        box-sizing: border-box;
        border: 1px solid #ebeef5;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;
        overflow: hidden;
    }
    .zm-message-group {
        margin-left: 13px;
        margin-right: 8px;
    }
    .zm-message-btn {
        position: absolute;
        top: 18px;
        right: 27px;
        /*cursor: pointer;*/
        color: #909399;
        font-size: 14px;
    }
    .zm-message-title {
        padding-bottom: 5px;
        font-weight: 700;
        font-size: 16px;
        color: #303133;
        margin: 0;
        border-bottom: 1px solid rgb(188,188,188);
    }
    .zm-message-content {
        font-size: 14px;
        line-height: 21px;
        margin: 6px 0 0;
        color: #606266;
        text-align: justify;
        height: 75px;
    }
</style>


// WEBPACK FOOTER //
// ../../src/components/ZmMessage/Message.vue